import { effect } from '@preact/signals-core';
import type { EventBus } from '../core/event-bus';
import type { Store } from '../core/store';
import { t } from '../content';

/** The splash markup is inlined in index.html so it paints before any script; this only wires it up. */
export function bindSplash(store: Store, bus: EventBus): void {
  const splash = document.getElementById('splash');
  const button = document.getElementById('enter') as HTMLButtonElement | null;
  if (!splash || !button) return;

  effect(() => {
    const state = store.loadState.value;
    const ready = state === 'ready';
    button.disabled = !ready;
    button.setAttribute('aria-busy', String(state === 'loading'));
    if (ready) button.textContent = t('splash.enter');
    else if (!button.querySelector('.spin')) {
      const spin = document.createElement('span');
      spin.className = 'spin';
      spin.setAttribute('aria-hidden', 'true');
      button.replaceChildren(spin, t('splash.loading'));
    }
    splash.hidden = state === 'no-webgl' || state === 'error' || store.phase.value !== 'splash';
  });

  button.addEventListener('click', () => {
    if (store.loadState.value !== 'ready') return;
    splash.classList.add('leaving');
    bus.emit('ui:enter');
  });
}
